import {StyleSheet} from 'react-native';

import {cloudLight} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  listItem: {
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
  },
});
